import { IProjectCollateralCategory } from '~/@api/generated-api-types-project/Api'

const projectCollateralCategoryLabels = {
  [IProjectCollateralCategory.Residential]: 'Rezidenčná',
  [IProjectCollateralCategory.Commercial]: 'Komerčná',
  [IProjectCollateralCategory.Land]: 'Pozemky',
  [IProjectCollateralCategory.Recreational]: 'Rekreačné',
  [IProjectCollateralCategory.Other]: 'Iné',
}

export function getProjectCollateralCategoryLabel(
  key: IProjectCollateralCategory
) {
  return projectCollateralCategoryLabels[key]
}
